export default __webpack_public_path__ + "static/media/legal-team-prosecutor.58abc3ec.png";